import { Grid } from '@mui/material'
import StatCard from './StatCard'

const RenderKPIs = ({
  openTasksCount,
  dealsEndingSoonCount,
  contractsSentCount,
  dealsWonCount,
  isLoading = false,
}: {
  openTasksCount: number
  dealsEndingSoonCount: number
  contractsSentCount: number
  dealsWonCount: number
  isLoading?: boolean
}) => {
  return (
    <>
      <Grid item xs={12} md={3}>
        <StatCard
          label="Open Tasks"
          value={openTasksCount}
          hint="Tasks you own that aren’t Done"
          isLoading={isLoading}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <StatCard
          label="Deals Ending ≤30d"
          value={dealsEndingSoonCount}
          hint="Deals with any product ending soon"
          isLoading={isLoading}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <StatCard
          label="Contracts Sent (mo)"
          value={contractsSentCount}
          hint="This month, owned by you"
          isLoading={isLoading}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <StatCard
          label="Deals Won"
          value={dealsWonCount}
          hint="Total deals won"
          isLoading={isLoading}
        />
      </Grid>
    </>
  )
}
export default RenderKPIs
